import React, { useRef, useState } from 'react'
import { useMutation } from 'react-query';
import { useNavigate, useLocation } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast'
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import {
    onlineAccountInfo,
    onlineCollection,
    onlineCollectionCard,
    addDonationPayment
} from '../../../api/apiServices';
import generateTransactionId from "../../../services/generateTransactionId";

const mtnServiceID = `${process.env.REACT_APP_MTN_SERVICE_ID}`
const vodafoneServiceID = `${process.env.REACT_APP_VODAFONE_SERVICE_ID}`
const cardServiceId = `${process.env.REACT_APP_VISA_CARD_ID}`
const languageId = `${process.env.REACT_APP_LANGUAGE_ID}`
const countryCode = `${process.env.REACT_APP_COUNTRY_CODE}`
const transCurrencyIso = `${process.env.REACT_APP_TRANS_CURRENCY_ISO}`

const Donations = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/donations";

    const year = 2024;
    const years = Array.from(new Array(20), (val, index) => index + year)

    let curr = new Date();
    let paymentYear = curr.getFullYear().toString();

    curr.setDate(curr.getDate());
    let date = curr.toISOString().substring(0, 10);

    const userEmailRef = useRef();

    const [isVisaCard, setIsVisaCard] = useState(false)
    const [isMoMo, setIsMoMo] = useState(false)

    const [isAnonymous, setIsAnonymous] = useState(false)
    const [person_type, setPersonType] = useState("")

    const [payment_type, setPaymentType] = useState("DN")
    const [payment_mode, setPaymentMode] = useState("")

    const [email, setEmail] = useState("")
    const [mobile_number, setMobileNumber] = useState("")
    const [fullname, setFullname] = useState("")
    const [card_fullname, setCardFullname] = useState("")
    const [amount, setAmount] = useState("")
    const [payPartnerServiceId, setPayPartnerServiceId] = useState("")
    const [transaction_id, setTransactionId] = useState("")

    const [card_number, setCardNumber] = useState("")
    const [expiryDateMonth, setExpiryDateMonth] = useState("")
    const [expiryDateYear, setExpiryDateYear] = useState("")
    const [cvv, setCvv] = useState("")

    const handleAnonymousPerson = (e) => {
        const anonymousOption = e.target.value
        setPersonType(anonymousOption)
        if (anonymousOption === 'YES') {
            setIsAnonymous(true)
        } else {
            setIsAnonymous(false)
        }
    }

    const handleAccountInfo = (e) => {
        let mobileNumber = ""
        let payerMobileNumber = mobile_number

        if (payerMobileNumber.substring(4, 0) === '2330') {
            mobileNumber = payerMobileNumber.replace('0', '');
        } else {
            mobileNumber = payerMobileNumber;
        }
        if (mobileNumber === "") {
            toast.error("Please enter your mobile number",
                {
                    duration: 5000,
                    className: "toast-message",
                });
            return false
        }
        else if (mobileNumber === "+233") {
            toast.error("The mobile number is not valid. Please provide a valid mobile number to continue",
                {
                    duration: 5000,
                    className: "toast-message",
                });
            return false;
        }
        else {
            const infoData = {
                CustomerAcctNo: mobileNumber,
                PayPartnerServiceId: payPartnerServiceId,
                LanguageId: languageId,
                CountryCode: countryCode,
            }
            getMemberInfoMutation.mutate(infoData);
        }
    }

    const getMemberInfoMutation = useMutation(onlineAccountInfo, {
        onSuccess: async (res) => {
            if (res.data.Status === false && res.status === 201) {
                toast.error(res.data.Message, {
                    duration: 5000,
                    className: "toast-message",
                });
                return false
            }
            if (res.data.Status === false && res.status === 200) {
                toast.error(res.data.Message, {
                    duration: 5000,
                    className: "toast-message",
                });
                return false
            }
            if (res.data.Status === true) {
                generateTransactionId().then((result) => {
                    setTransactionId(result)
                    setFullname(res.data.AccountName)
                    userEmailRef.current.focus();
                    return true;
                })
            }
        },
        onError: async (err) => {
            toast.error(err.message, {
                duration: 5000,
                className: "toast-message",
            });
            return false
        }
    })


    const handleDonationPayment = (e) => {
        e.preventDefault();

        const paymtMode = payPartnerServiceId;
        if (paymtMode === `${cardServiceId}`) {
            const cardPaymentData = {
                PayPartnerServiceId: payPartnerServiceId,
                Amount: amount,
                AccountNoOrCardNoOrMSISDN: card_number,
                AccountName: card_fullname.toLocaleUpperCase(),
                TransactionId: transaction_id,
                Narration: "Donation",
                TransCurrencyIso: transCurrencyIso,
                ExpiryDateMonth: parseInt(expiryDateMonth),
                ExpiryDateYear: parseInt(expiryDateYear.substring(2)),
                Cvv: parseInt(cvv),
                LanguageId: languageId,
            }
            onlineCollectionCardMutation.mutate(cardPaymentData)
        } else {
            const momoPaymentData = {
                PayPartnerServiceId: payPartnerServiceId,
                Amount: amount,
                AccountNoOrCardNoOrMSISDN: mobile_number,
                AccountName: fullname.toLocaleUpperCase(),
                TransactionId: transaction_id,
                LanguageId: languageId,
                Narration: "Donation",
                TransCurrencyIso: transCurrencyIso,
                ExpiryDateMonth: 0,
                ExpiryDateYear: 0,
                Cvv: 0,
            };
            onlineCollectionMutation.mutate(momoPaymentData)
        }
    }

    const onlineCollectionCardMutation = useMutation(onlineCollectionCard, {
        onSuccess: async (res) => {
            if (res.data.Status === true) {
                const cardPaymentData = {
                    PayPartnerServiceId: payPartnerServiceId,
                    amount: parseFloat(amount).toFixed(2),
                    mobile_number: mobile_number,
                    email: email,
                    fullname: fullname.toLocaleUpperCase(),
                    payment_type: payment_type.toLocaleUpperCase(),
                    payment_mode: payment_mode.toLocaleUpperCase(),
                    transaction_id: transaction_id,
                };

                addCardPaymentMutation.mutate(cardPaymentData);
            } else if (res.data.Status === false) {
                toast.error(res.data.Message, {
                    duration: 5000,
                    className: "toast-message",
                })
                setIsVisaCard(false)
                setIsMoMo(false)
                navigate(from, { replace: true });
            } else {
                toast.error(res.data.message, {
                    duration: 5000,
                    className: "toast-message",
                })
                setIsVisaCard(false)
                setIsMoMo(false)
                navigate(from, { replace: true });
            }
        },
        onError: async (err) => {
            toast.error(err.message, {
                duration: 5000,
                className: "toast-message",
            })
            setIsVisaCard(false)
            setIsMoMo(false)
        }
    })

    const addCardPaymentMutation = useMutation(addDonationPayment, {
        onSuccess: async (res) => {
            if (res.success === true) {
                toast.success(res.message,
                    {
                        duration: 5000,
                        className: "toast-message",
                    }
                )

                setPaymentType("")
                setMobileNumber("233")
                setFullname("")
                setAmount("")
                setIsVisaCard(false)
                setIsMoMo(false)
                navigate(from, { replace: true });
            } else {
                toast.success(res.message,
                    {
                        duration: 5000,
                        className: "toast-message",
                    }
                )
                setIsVisaCard(false)
                setIsMoMo(false)
                setPaymentType("")
                setMobileNumber("233")
                setFullname("")
                setAmount("")
                navigate(from, { replace: true });
            }
        },
        onError: async (err) => {
            toast.error(err.message, {
                duration: 5000,
                className: "toast-message",
            })
            setIsVisaCard(false)
            setIsMoMo(false)
            setPaymentType("")
            setMobileNumber("233")
            setFullname("")
            setAmount("")
            navigate(from, { replace: true });
        }
    })


    const onlineCollectionMutation = useMutation(onlineCollection, {
        onSuccess: async (res) => {
            if (res.data.Status === true) {
                const momoPaymentData = {
                    PayPartnerServiceId: payPartnerServiceId,
                    amount: parseFloat(amount).toFixed(2),
                    mobile_number: mobile_number,
                    email: email,
                    fullname: fullname.toLocaleUpperCase(),
                    payment_type: payment_type.toLocaleUpperCase(),
                    payment_mode: payment_mode.toLocaleUpperCase(),
                    transaction_id: transaction_id,
                };
                addMomoMutation.mutate(momoPaymentData);
            } else {
                toast.error(res.data.message, {
                    duration: 5000,
                    className: "toast-message",
                })
                setIsVisaCard(false)
                setIsMoMo(false)
                navigate(from, { replace: true });
            }
        },
        onError: async (err) => {
            toast.error(err.message, {
                duration: 5000,
                className: "toast-message",
            })
            setIsVisaCard(false)
            setIsMoMo(false)
            navigate(from, { replace: true });
        }
    })

    const addMomoMutation = useMutation(addDonationPayment, {
        onSuccess: async (res) => {
            if (res.success === true) {
                toast.success(res.message,
                    {
                        duration: 5000,
                        className: "toast-message",
                    }
                )
                setIsVisaCard(false)
                setIsMoMo(false)
                setPaymentType("")
                setMobileNumber("233")
                setAmount("")
                navigate(from, { replace: true });
            } else {
                toast.success(res.message,
                    {
                        duration: 5000,
                        className: "toast-message",
                    }
                )
                setIsVisaCard(false)
                setIsMoMo(false)
                setPaymentType("")
                setMobileNumber("233")
                setFullname("")
                setAmount("")
                navigate(from, { replace: true });
            }
        },
        onError: async (err) => {
            toast.error(err.message, {
                duration: 5000,
                className: "toast-message",
            })
            setIsVisaCard(false)
            setIsMoMo(false)
            setPaymentType("")
            setMobileNumber("233")
            setFullname("")
            setAmount("")
            navigate(from, { replace: true });
        }
    })


    const handlePaymentOption = (e) => {
        const modeSelection = e.target.value

        if (modeSelection === `${cardServiceId}`) {
            setPayPartnerServiceId(modeSelection)
            setPaymentMode("B")
            setIsVisaCard(true)
            setIsMoMo(false)
        } else {
            setPaymentMode("M")
            setPayPartnerServiceId(modeSelection)
            setIsVisaCard(false)
            setIsMoMo(true)
        }
    }

    const handleCancel = () => {
        navigate('/')
    }

    const visaCardPayment = (
        <>
            <label htmlFor="card_number" className="col-sm-4 col-form-label">Card Number<span>&nbsp;&nbsp;*</span></label>
            <div className="col-sm-8">
                <input
                    type="tel"
                    name='card_number'
                    id='card_number'
                    placeholder='4531 0400 0960 0258'
                    style={{
                        height: "40px",
                        textTransform: "uppercase",
                    }}
                    required
                    onChange={(e) => setCardNumber(e.target.value)}
                    value={card_number}
                    className="form-control"
                />
            </div>
            <label htmlFor="card_fullname" className="col-sm-4 col-form-label">Name On Card<span>&nbsp;&nbsp;*</span></label>
            <div className="col-sm-8">
                <input
                    type="text"
                    name='card_fullname'
                    id='card_fullname'
                    placeholder='FullName On Card'
                    style={{
                        height: "40px",
                        textTransform: "uppercase",
                    }}
                    required
                    autoComplete='off'
                    value={card_fullname}
                    onChange={(e) => setCardFullname(e.target.value)}
                    className="form-control" />
            </div>
            <label htmlFor="cvc" className="col-sm-4 col-form-label">CVV<span>&nbsp;&nbsp;*</span></label>
            <div className="col-sm-2">
                <input
                    type="number"
                    name='cvc'
                    id='cvc'
                    placeholder='745'
                    pattern='\d{3,4}'
                    required
                    style={{
                        height: "40px",
                        textTransform: "uppercase",
                    }}
                    onChange={(e) => setCvv(e.target.value)}
                    value={cvv}
                    className="form-control"
                />
            </div>
            <label htmlFor="expiryDateMonth" className="col-sm-2 col-form-label">Expiry Date<span>&nbsp;&nbsp;*</span></label>
            <div className="col-sm-2">
                <select
                    type="text"
                    name='expiryDateMonth'
                    id='expiryDateMonth'
                    style={{
                        height: "40px",
                        textTransform: "uppercase",
                    }}
                    required
                    onChange={(e) => setExpiryDateMonth(e.target.value)}
                    value={expiryDateMonth}
                    className="form-control"
                >
                    <option>Month</option>
                    <option value={1}>01</option>
                    <option value={2}>02</option>
                    <option value={3}>03</option>
                    <option value={4}>04</option>
                    <option value={5}>05</option>
                    <option value={6}>06</option>
                    <option value={7}>07</option>
                    <option value={8}>08</option>
                    <option value={9}>09</option>
                    <option value={10}>10</option>
                    <option value={11}>11</option>
                    <option value={12}>12</option>
                </select>
            </div>
            <div className="col-sm-2">
                <select
                    type="text"
                    name='expiryDateYear'
                    id='expiryDateYear'
                    style={{
                        height: "40px",
                        textTransform: "uppercase",
                    }}
                    required
                    onChange={(e) => setExpiryDateYear(e.target.value)}
                    value={expiryDateYear}
                    className="form-control"
                >
                    <option>Year</option>
                    {years.map((year, index) =>
                        <option value={year} key={`year${index}`}>{year}</option>
                    )}
                </select>
            </div>
            <label htmlFor="amount" className="col-sm-4 col-form-label">Amount<span>&nbsp;&nbsp;*</span></label>
            <div className="col-sm-8">
                <input
                    type="number"
                    name='amount'
                    id='amount'
                    style={{
                        height: "40px",
                        textTransform: "uppercase",
                    }}
                    placeholder='Amount'
                    required
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    className="form-control" />
                <span>An additional fee may apply to this payment</span>
            </div>
            <label htmlFor="email" className="col-sm-4 col-form-label">Email Address<span>&nbsp;&nbsp;*</span></label>
            <div className="col-sm-8">
                <input
                    ref={userEmailRef}
                    type="email"
                    name='email'
                    id='email'
                    autoComplete='off'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="form-control" />
                <span>The email address is for acknowlegement purposes</span>
            </div>
        </>
    )

    const mobileMoneyPayment =
        <>

            <label htmlFor="mobile_number" className="col-sm-4">Mobile Number<span>&nbsp;&nbsp;*</span></label>
            <div className="col-sm-8">
                <PhoneInput
                    id="mobile_number"
                    inputStyle={{
                        paddingTop: 16,
                        paddingRight: 14,
                        paddingBottom: 15,
                        paddingLeft: 58,
                        fontSize: 16,
                        width: "100%",
                        zIndex: 1,
                        height: 40,
                        backgroundColor: "#F3F6F9",
                    }}

                    country={"gh"}
                    countryCodeEditable={false}
                    enableSearch={true}
                    value={mobile_number}
                    name="mobile_number"
                    onBlur={(e) => handleAccountInfo(e)}
                    onChange={(mobile_number) => setMobileNumber(mobile_number)}
                />
            </div>

            {!isAnonymous ?
                <>
                    <label htmlFor="fullname" className="col-sm-4 col-form-label">FullName<span>&nbsp;&nbsp;*</span></label>
                    <div className="col-sm-8">
                        <input
                            type="text"
                            name='fullname'
                            id='fullname'
                            placeholder='FullName'
                            style={{
                                height: "40px",
                                fontWeight: "bold",
                                textTransform: "uppercase",
                            }}
                            required
                            disabled
                            autoComplete='off'
                            value={fullname}
                            onChange={(e) => setFullname(e.target.value)}
                            className="form-control" />
                    </div>
                    <label htmlFor="email" className="col-sm-4 col-form-label">Email Address<span>&nbsp;&nbsp;*</span></label>
                    <div className="col-sm-8">
                        <input
                            ref={userEmailRef}
                            type="email"
                            name='email'
                            id='email'
                            autoComplete='off'
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="form-control" />
                        <span>The email address is for acknowlegement purposes</span>
                    </div>
                </>
                :
                <>
                    <label htmlFor="fullname" className="col-sm-4 col-form-label">FullName<span>&nbsp;&nbsp;*</span></label>
                    <div className="col-sm-8">
                        <input
                            type="text"
                            name='fullname'
                            id='fullname'
                            placeholder='FullName'
                            style={{
                                height: "40px",
                                fontWeight: "bold",
                                textTransform: "uppercase",
                            }}
                            required
                            disabled
                            autoComplete='off'
                            value={fullname}
                            onChange={(e) => setFullname(e.target.value)}
                            className="form-control" />
                    </div>
                    <label htmlFor="email" className="col-sm-4 col-form-label">Email Address<span>&nbsp;&nbsp;*</span></label>
                    <div className="col-sm-8">
                        <input
                            ref={userEmailRef}
                            type="email"
                            name='email'
                            id='email'
                            autoComplete='off'
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="form-control" />
                        <span>The email address is for acknowlegement purposes</span>
                    </div>
                </>
            }
            <label htmlFor="amount" className="col-sm-4 col-form-label">Amount<span>&nbsp;&nbsp;*</span></label>
            <div className="col-sm-8">
                <input
                    type="number"
                    name='amount'
                    id='amount'
                    style={{
                        height: "40px",
                        textTransform: "uppercase",
                    }}
                    placeholder='Amount'
                    required
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    className="form-control" />
                <span>An additional fee may apply to this payment</span>
            </div>
        </>

    const paymentForm = (
        <form onSubmit={handleDonationPayment}>
            <div className="form-group row">
                <fieldset className="col-sm-6">
                    <label htmlFor="person_type" className="col-sm-4 col-form-label">Anonymous Person ?<span>&nbsp;&nbsp;*</span></label>
                    <div className="col-sm-8">
                        <select
                            type="text"
                            name="person_type"
                            id="person_type"
                            style={{
                                height: "40px",
                                textTransform: "uppercase",
                            }}
                            value={person_type}
                            onChange={handleAnonymousPerson}
                            required
                            className="form-control"
                        >
                            <option>Select Option</option>
                            <option value={"YES"}>YES</option>
                            <option value={"NO"}>No</option>
                        </select>
                    </div>

                    <label htmlFor="payment_mode" className="col-sm-4 col-form-label">Mode of Payment<span>&nbsp;&nbsp;*</span></label>
                    <div className="col-sm-4">
                        <label htmlFor="mtn_option">
                            <input
                                type="checkbox"
                                id="mtn_option"
                                name="payPartnerServiceId"
                                checked={payPartnerServiceId === mtnServiceID}
                                value={mtnServiceID}
                                onChange={handlePaymentOption}
                            />
                        </label>
                            MTN Mobile Money
                    </div>
                    {/* <label htmlFor="payment_mode" className="col-sm-4 col-form-label"></label> */}
                    <div className="col-sm-4">
                        <label htmlFor="voda_option">
                            <input
                                type="checkbox"
                                id="voda_option"
                                name="payPartnerServiceId"
                                checked={payPartnerServiceId === vodafoneServiceID}
                                value={vodafoneServiceID}
                                onChange={handlePaymentOption}
                            />
                        </label>
                            Telecel Cash
                    </div>
                    {/* <label htmlFor="payment_mode" className="col-sm-4 col-form-label"></label>
                    <div className="col-sm-8">
                        <label htmlFor="card_option">
                            <input
                                type="checkbox"
                                id="card_option"
                                name="payPartnerServiceId"
                                checked={payPartnerServiceId === cardServiceId}
                                value={cardServiceId}
                                onChange={handlePaymentOption}
                            />
                            Visa/Credit/Debit Card
                        </label>
                    </div> */}
                    {/* {isVisaCard && visaCardPayment} */}
                    {isMoMo && mobileMoneyPayment}
                </fieldset>
            </div>
            <div className='panel-footer'>
            <div className="row">
						<div className="col-sm-2">
							<button
								type="submit"
								className="btn btn-success btn-block"
							>
								Submit
							</button>
							&nbsp;&nbsp;&nbsp;&nbsp;
						</div>
						<div className="col-sm-2">
							<button
								type="button"
								onClick={handleCancel}
								className="btn btn-danger btn-block"
							>
								Cancel
							</button>
						</div>
					</div>
            </div>
        </form>
    );


    return (
        <>
            <Toaster toastOptions={{ position: "top-center" }} />
            <section className="content-header">
                <h1><i className="fas fa-bank"></i> Make Donations</h1>
            </section>
            <section className="content">
                <div className="box">
                    <div className="box-body">
                        <div className="panel panel-default panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h4 className="panel-title">
                                            <span>Donation Payments</span>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className="panel-body">
                                {paymentForm}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Donations